<template>
  <b-modal
    id="mobile-how-modal"
    v-model="show" 
    ok-only 
    centered 
    size="lg" 
    footer-class="border-top d-none d-sm-block"
    header-class="d-none d-sm-block"
    :ok-title="hebrew ? 'סגור' : 'Close'"
    ok-variant="secondary"
    >
    <template slot="modal-header">{{hebrew ? 'איך זה עובד' : 'How it works'}}</template>
    <div class="mobile-modal-top bg-secondary position-fixed w-100 d-block d-sm-none">
      <div class="row">
        <div class="col-8">
          <h3>{{hebrew ? 'איך זה עובד' : 'How it works'}}</h3>
        </div>
        <div @click="show=false" class="close-icon col-4" v-bind:class="{'text-left': hebrew, 'text-right': !hebrew}">
          <i class="fas fa-times"></i>
        </div>
      </div>
    </div>    
    <div class="how-to-text" v-if="hebrew">
      <p>מנוע החיפוש "זיהוי אזכורים תנכיים ותלמודיים" מבית דיקטה, הוא כלי למציאת אזכורים תלמודיים ותנ״כיים בטקסטים. הכלי משמש לאיתור פסוקים מהתלמוד ומהתנ״ך בטקסטים שיתכן ומכילים מילים/ביטויים שנכתבו בהשראת מקורות תלמודיים ותנ״כיים.</p>
      <p>תוצאות החיפוש כוללות מגוון רחב של אזכורים תלמודיים ותנ״כיים, בשל המנוע החכם המתחשב בהבדלי איות והטיה אפשריים.</p>
      <p>
        דוגמה: חיפוש איזכור עבור הפיוט של רבי יהודה הלוי
        <strong
          class="f-narkis"
        >״בסוף מערב איך אטעמה את אשר אכל ואיך יערב איכה״</strong>
        , יציג את הפסוק משמואל
        <strong
          class="f-narkis"
        >״טֹוב לְרָע אִם יִטְעַם עַבְדְּךָ אֶת אֲשֶׁר אֹכַל וְאֶת אֲשֶׁר אֶשְׁתֶּה״</strong>
        [שמואל ב יט, לו] וממסכת שבת
        <strong
          class="f-narkis"
        >״זקנים משתנות אם יטעם עבדך את אשר אוכל ואת אשר אשתה״</strong>
        [שבת קנב]
      </p>
      <h2>נהלו את התוצאות שלכם</h2>
      <p>רמת דיוק: הכלי מאפשר לבחור בין הצגת אזכורים ברמת דיוק גבוהה בלבד, לבין הצגת כל האזכורים ברמות דיוק שונות.</p>
      <p>סינון תוצאות: ניתן לבחור אם לכלול אזכורים מהתנ״ך בלבד, מהשנה בלבד או מהתלמוד בלבד או משלושתם.</p>
      <p>תצוגה: תצוגת ׳הערות שוליים׳ תציג במרוכז את כל האזכורים.
        תצוגת ׳גרף׳ תציג את מפה של קשרים בין האזכורים לבין הספרים בתנ״ך, בתלמוד ובמשנה.
      </p>
      <h2>אופן השימוש בכלי</h2>
      <ul>
        <li>הזינו טקסט בתיבה שבדף הבית ולחצו על ״מצא אזכורים״.</li>
        <li>בדף התוצאות, הטקסט יופיע בצד ימין ומילים שעבורן קיים איזכור אחד או יותר יודגשו.</li>
        <li>כדי לקבל תוצאות שזהות לטקסט לחצו על ״הצג רק מקורות זהים לטקסט״.</li>
        <li>בצד שמאל יוצגו, לפי סדר הופעתם בטקסט, רשימה של האזכורים. רשימת האזכורים מסודרת על פי סדר הופעתם בתלמוד ובתנ״ך, ללא קשר לרמת הדיוק.</li>
        <li>לחיצה על האיזכור בצד ימין תגלול לאיזכור הרלוונטי בצד שמאל.</li>
        <li>על מנת להזין טקסט חדש, או לערוך את הטקסט הקיים לחצו על הכפתור ״טענו טקסט חדש״ המופיע בחלק העליון של אזור הטקסט שלכם.</li>        
      </ul>
      <p>הערה: צמדי מילים נפוצים כגון ״ריח ניחוח״, המופיעים בתנ״ך למעלה מ 3 פעמים, לא יכללו בסריקת הטקסט. ניתן למצוא עבורם תוצאות במנוע החיפוש בתנ״ך מבית דיקטה.</p>
      <small class="d-block border-top border-bottom py-3" dir="ltr" style="text-align:left">
        HEBREW TEXT DATABASE ETCBC4B
Peursen, Prof. Dr. W.T. van (Eep Talstra Centre for Bible And Computing, VU University Amsterdam); Sikkel, M. Sc. C. (Eep Talstra Centre for Bible And Computing, VU University Amsterdam); Roorda, Dr. D. (Data Archiving and Networked Services, Royal Netherlands Academy of Arts and Sciences) (2015): Hebrew Text Database ETCBC4b. DANS. <a href="https://doi.org/10.17026/dans-z6y-skyh" target="_blank">https://doi.org/10.17026/dans-z6y-skyh</a>
      </small>
      <small class="d-block mt-2">
הגרסה הדיגיטלית של תלמוד קורן נואה על שמו של וויליאם דייוידסון, יצא לאור בהוצאת קורן, מנוקד על ידי 
<a href="http://dicta.org.il/index-he.html" target="_blank">דיקטה - המרכז הישראלי לניתוח טקסטים</a>  - ושוחרר תחת רשיון מסוג
<a href="https://creativecommons.org/licenses/by-nc/4.0/legalcode" target="_blank">CC BY-NC</a>.
      </small>
    </div>
    <div v-else class="how-to-text">
      <p>
      Dicta's Citation Finder searches for Talmudic and Biblical references in texts. 
      The tool is used to find verses from the Talmud, Mishnah and the Bible in texts that contain words and phrases inspired by Talmudic and Biblical sources.</p>
      <p>The Citation Finder's search engine takes various methods of spelling and meanings into account 
      and returns a wide range of Talmudic and Biblical references.</p>
      <p>For example, searching for the following citation by Rabbi Yehuda Halevi:
        <span class="d-block f-narkis font-weight-bold">"בסוף מערב איך אטעמה את אשר אכל ואיך יערב איכה"</span> 
        returns the following results:
        <br/>
          <span class="f-narkis d-inline-block text-right font-weight-bold" style="direction:rtl">"טֹוב לְרָע אִם יִטְעַם עַבְדְּךָ אֶת אֲשֶׁר אֹכַל וְאֶת אֲשֶׁר אֶשְׁתֶּה"
             [שמואל ב יט, לו]</span>
          <br/>   
          <span class="f-narkis d-inline-block text-right font-weight-bold" style="direction:rtl">"קנים משתנות אם יטעם עבדך את אשר אוכל ואת אשר אשתה" 
            [שבת קנב]
        </span>
      </p>
      <h3>Manage your results</h3>
      <p>Accuracy: The Citation Finder allows you to select the level of accuracy required for your search.</p>
      <p>Filtering: View results for Bible only, Mishnah only, Talmud only or all three combined.</p>
      <p>Display: Choose footnote display to see all results listed or a graph display which plots out 
        connections the citations in the Bible, Mishnah and Talmud.
      </p>
      <h3>How to use:</h3>
      <ul>
        <li>Enter text in the text area and click on the "Find Citations" button.</li>
        <li>On the results page, the original text will appear on the right side and words with citations will be marked.</li>
        <li>For results identical to your text, click on "Display only citations identical to source".</li>        
        <li>The citations will be displayed on the left side of the screen in the order of their respective appearance in the sources.</li>
        <li>Clicking on a highlighted word on the right side will scroll to its corresponding citation on the left side.</li>
        <li>To perform a new search, click on the "Reload Text" button that appears above the original text on the right side.</li>        
      </ul>
      <p>
        Note: Common phrases such as <span class="f-narkis font-weight-bold">"ריח ניחוח"</span> that appear in the Bible more than three times will not be included 
        in the search results. Dicta's <a href="https://search.dicta.org.il/?lang=en" target="_blank">Bible Search</a> tool can be used for these types of searches.
      </p>
      <small class="d-block border-top border-bottom py-3">
       HEBREW TEXT DATABASE ETCBC4B
      Peursen, Prof. Dr. W.T. van (Eep Talstra Centre for Bible And Computing, VU University Amsterdam); Sikkel, M. Sc. C. (Eep Talstra Centre for Bible And Computing, VU University Amsterdam); Roorda, Dr. D. (Data Archiving and Networked Services, Royal Netherlands Academy of Arts and Sciences) (2015): Hebrew Text Database ETCBC4b. DANS. <a href="https://doi.org/10.17026/dans-z6y-skyh" target="_blank">https://doi.org/10.17026/dans-z6y-skyh</a>
      </small>
      <small class="d-block mt-2">
      The William Davidson digital version of the Koren Talmud was vocalised by <a href="http://dicta.org.il/index.html" target="_blank">Dicta
      - The Israel Institute for Text Analysis</a> and released under
<a href="https://creativecommons.org/licenses/by-nc/4.0/legalcode" target="_blank">CC BY-NC</a> license.  
      </small>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "about-dialog",
  props: ["value"],
  computed: {
    hebrew () {
      return this.$settings.hebrew
    }, 
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>
<style lang="scss">
  @media screen and (max-width: 767px) {
    #mobile-how-modal{
      -webkit-overflow-scrolling: touch;
      direction: ltr;
      text-align: left;
      .modal-dialog {
        margin: 0!important;
      }
      .modal-content {
        border-radius: 0!important;
        height: 100vh;
        overflow-y: scroll;
        overflow-x:hidden;
        background:white;
      }
      .mobile-modal-top{
          height: 50px;
          top:0;
          right:0;
          padding:15px;
          z-index: 1;
          h3{text-decoration:none;}
      }
      .how-to-text{
          padding-top:50px;
          max-height: 88vh;
          overflow-y: scroll;
          overflow-x:hidden;
      }
      @media screen and (max-width: 667px) {
        .how-to-text{
          max-height: 83vh;
        }
      }      
    }
    .he #mobile-how-modal {
      text-align: right;
      direction: rtl;
    }
  }
</style>
<style scoped>
.how-to-text {
  max-height: 70vh;
  overflow: auto;
}
</style>
